import React, { Component } from "react";
import { connect } from "react-redux";
import { EditUserDialog } from "../dialogs/EditUserDialog";
import { editUser } from "../redux/actions/userActions";

class EditUser extends Component {
  state = {
    uid: "",
    name: "",
    email: "",
    role: "",
    pass: "",
    passConfirm: "",
    passDoNotMatch: false,
    saveAvaliable: false
  };

  componentDidMount() {
    const { selectedUserKey, users } = this.props;
    if (!selectedUserKey) return;
    const { uid, name, role, email } = users[selectedUserKey];
    this.setState({
      uid,
      name,
      role,
      email,
      saveAvaliable: true
    });
  }

  onSave = () => {
    const { editUser, onClose, selectedUserKey } = this.props;
    const { name, email, role, pass } = this.state;
    editUser({
      selectedUserKey,
      name,
      email,
      role,
      password: pass,
    });

    onClose();
  };

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onEmailChange = email => this.setState({ email }, this.checkSaveAvaliable);

  onRoleChange = role => this.setState({ role }, this.checkSaveAvaliable);

  onPassChange = pass => this.setState({ pass }, this.checkSaveAvaliable);

  onPassConfirmChange = passConfirm =>
    this.setState({ passConfirm }, this.checkSaveAvaliable);

  checkSaveAvaliable = () => {
    const {
      name,
      email,
      role,
      pass,
      passConfirm
    } = this.state;

    this.setState({
      passDoNotMatch: pass !== passConfirm && passConfirm !== ""
    });
   
    let saveAvaliable = true;
    if (
      name === "" ||
      email === "" ||
      role === "" ||
      pass !== passConfirm
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  render() {
    const { onClose, users, selectedUserKey } = this.props;
    const {
      name,
      email,
      role,
      pass,
      passConfirm,
      saveAvaliable,
      passDoNotMatch,
      organizationKey
    } = this.state;

    return (
      <EditUserDialog
        currentUser={users[selectedUserKey]}
        name={name}
        email={email}
        role={role}
        pass={pass}
        passConfirm={passConfirm}
        onCancel={onClose}
        onSave={this.onSave}
        saveAvaliable={saveAvaliable}
        onNameChange={this.onNameChange}
        onEmailChange={this.onEmailChange}
        onRoleChange={this.onRoleChange}
        onPassChange={this.onPassChange}
        onPassConfirmChange={this.onPassConfirmChange}
        passDoNotMatch={passDoNotMatch}
        organizationKey={organizationKey}
      />
    );
  }
}

const mapStateToProps = state => ({
  users: state.data.users,
});

const mapDispatchToProps = {
  editUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditUser);
